<template>
  <div>
    <v-row>
      <v-col>
        <VTextField
          :value="massBalanceInfos.network.name"
          hideDetails
          outlined
          disabled
          data-cy="component-Name"
          :label="$t('forms.labels.network')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VAutocomplete
          v-model="selectedComponents"
          :label="$t('forms.labels.components')"
          :items="massBalanceInfos.components"
          outlined
          multiple
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    name: 'MassBalanceForm',
    components: {
        VAutocomplete, VTextField,
    },
    props: {
        massBalanceId: {
            type: String,
            default: null,
        },
        workOrderId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            massBalanceInfos: {
                components: [],
                ignore: [],
                network: {
                    id: '',
                    name: '',
                },
            },
            selectedComponents: [],
        };
    },
    created() {
        this.getComponents();
    },
    methods: {
        async getComponents() {
            const { data } = await this.$rq.getMassBalanceInfos(this.workOrderId, this.massBalanceId);
            this.massBalanceInfos = data;
            this.selectedComponents = data.displayed;
        },

        updateData() {
            this.$emit('sendData', {
                selectedComponents: this.selectedComponents,
                components: this.massBalanceInfos.components,
                ignore: this.massBalanceInfos.ignore,
            });
        },
    },
};
</script>
